import { reactive, ref, computed, onBeforeMount } from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import Vue from 'vue'
import * as common from '@/util/common'
import * as apiQA from '@/api/qa'
import {propagateCheckedRecursively, getCheckedNodeItemTypeAndIds, setNodeCheckByItemTypeAndIds, getCheckedProductIds} from '@/logic/common/CommonQA'
import { searchByKeyword, getSearchText, getIsFuzzy } from '@/util/search'
import * as logicCommonBookList from '@/logic/common/CommonBookList'
import * as _ from 'lodash'

/**
 * 書籍一覧画面
 */
export const getGroup = (props, context) => {

  onBeforeMount(() => {
    // 初期表示
    group1.init()
  })

  const group1 = reactive({

    // モード(list: 一覧表示(ドリルダウン)モード、search: キーワード検索モード )
    mode: computed({
      get: () => {
        return store.state.bookList.mode
      },
      set: (mode) => {
        store.dispatch('bookList/setMode', mode)
      }
    }), 

    // 最後に検索実行したキーワード
    lastSearchedKeyword: '',

    // キーワード検索中判定
    isKeywordSearch: computed(() => {
      return (group1.mode === 'search' && group1.lastSearchedKeyword !== '')
    }),

    // 「検索をクリア」を押せるか？ボタン
    isSearchConditionClearable: computed(() => {
      return (group1.mode === 'search' && (group1.lastSearchedKeyword !== '' || group1.idMapListOfCheckedProducts.length > 0))
    }),

    // ### ヘッダエリア ###
    // キーワード入力欄に入力した文字列
    search_text: computed(() => {
      return getSearchText(group1.searchCategory)
    }),

    // 表記の揺れを含む：0(曖昧検索),1(一致検索)
    is_fuzzy: computed(() => {
      return getIsFuzzy(group1.searchCategory)
    }),
    
    // 検索カテゴリ（選択肢）
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    }),
    
    // ### パッケージ＆商品一覧エリア ###
    packagesAndProductsDataExists: false, // パッケージ＆商品データ存在フラグ

    // 絞り込みエリアのヒット件数表示フラグ
    isSearchCountShown: computed(() => {
      return (group1.mode === 'search' && group1.search_text !== '')
    }),

    // ツリーの各ノートの親ノードの参照を格納するオブジェクト
    parentNodeMap: {},
    // パッケージ＆商品ツリーデータ
    packagesAndProductsAreaTreeData: {},
    // 単体書籍リスト
    packagesAndProductsAreaBooks: [],

    single_books: [], // 単体書籍（データバインディング用）

    // チェックされている商品の商品IDと書籍IDのリスト
    idMapListOfCheckedProducts: computed(() => {
      return store.state.bookList.idMapListOfCheckedProducts
    }),


    allBookIdsForProductIdMap: {}, // 商品IDに対する全書籍IDリストの対応マップ

    // データロード完了フラグ
    isListPackagesAndProductsLoaded: false,

    
    // ### 書籍一覧エリア ###
    booksDataExists: false, // 書籍データ存在フラグ

    booksAreaProducts: [],
    booksAreaBooks: [],

    // 書籍一覧エリア表示用データロード完了フラグ
    isListBooksLoaded: false,


    // ### 書籍目次エリア ###
    bookListTableOfContentsExists: false, // 書籍目次ツリーデータ存在フラグ

    bookListTableOfContentsAreaTreeData: {}, // 書籍目次ツリーデータ

    // 目次を表示中の書籍の種類(package_book=パッケージ商品、single_book=単体書籍)
    currentBookType: '',
    // 目次を表示中の書籍のID
    currentBookId: computed({
      get: () => {
        return store.state.bookList.bookId
      },
      set: (value) => {
        store.dispatch('bookList/setBookId', value)
      }
    }),
    // 目次を表示中の書籍名
    currentBookName: computed({
      get: () => {
        return store.state.bookList.bookName
      },
      set: (value) => {
        store.dispatch('bookList/setBookName', value)
      }
    }),

    // ### 目次のドリルダウン表示制御（SP用） ###
    parentNodeId: -1, // 親階層のID(SP用)：ルートの場合、親が無いので-1
    currentNodeId: 0, // 現在のノードID
    currentTitleFirstLine: '', // 現在の階層のタイトル1行目(SP用)
    currentTitleAfterSecondLines: [], // 現在の階層のタイトル2行目以降(SP用)
    currentTableOfContents: [], // 現在の階層の目次リスト(SP用)

    // 現在表示しているメインエリアのリストのタイプ（SP用）
    // （book=書籍一覧エリア / contents=目次一覧エリア）
    mainListType: computed(() => {
      return store.state.bookList.mainListType
    }),

    // 現在の書籍エリア表示判定（SP用）
    isMainHeadingBookNameShown: computed(() => {
      return (group1.mainListType === 'contents')
    }),

    // スクロール高さを指定するHTMLクラス
    // 目的：メインエリアのヘッダの表示数により、スクロール高さを変える（高さを指定するHTMLクラスを切り替える）
    scrollHeightClass: computed(() => {
      if (group1.isMainHeadingBookNameShown && group1.isKeywordSearch) {
        // ヘッダ(.main-heading-row)2分の高さを指定するクラス
        return 'is-2-main-heading-shown'
      } else if (group1.isMainHeadingBookNameShown || group1.isKeywordSearch) {
        // ヘッダ(.main-heading-row)1分の高さを指定するクラス
        return 'is-1-main-heading-shown'
      } else {
        return ''
      }
    }),
    
    // ### SPのキーワード検索の「前へ」「次へ」ナビゲーション機能 ###
    // キーワードの存在するページ数(SP用)
    pageCountForSPKeywordSearch: 0,

    // すべてのキーワード件数(SP用)
    totalKeywordCount: computed(() => {
      const booksAreaProducts = group1.booksAreaProducts
      const booksAreaBooks = group1.booksAreaBooks

      let total = 0
      for (let i = 0; i < booksAreaProducts.length; i++) {
        for (let k = 0; k < booksAreaProducts[i].books.length; k++) {
          total += booksAreaProducts[i].books[k].search_count ?? 0
        }
      }
      for (let i = 0; i < booksAreaBooks.length; i++) {
        total += booksAreaBooks[i].search_count ?? 0
      }

      return total
    }),

    // 現在のページに存在するキーワード件数(SP用)
    keywordCountInPage: 0,
    // ページ番号(SP用)
    pageNoForSPKeywordSearch: 0,

    // 前のページ番号(SP用)
    prevPageNoForSPKeywordSearch: computed(() => {
      return group1.pageNoForSPKeywordSearch - 1
    }),
    // 次のページ番号(SP用)
    nextPageNoForSPKeywordSearch: computed(() => {
      return group1.pageNoForSPKeywordSearch + 1
    }),

    // 前のページが存在するか
    hasPrevPageForSPKeywordSearch: computed(() => {
      return (group1.pageNoForSPKeywordSearch > 1)
    }),
    // 次のページが存在するか
    hasNextPageForSPKeywordSearch: computed(() => {
      return (group1.pageNoForSPKeywordSearch < group1.pageCountForSPKeywordSearch)
    }),

    // 前の書籍情報
    prevBookForSPKeywordSearch: null,
    // 次の書籍情報
    nextBookForSPKeywordSearch: null,

    // SPキーワード検索のページネーション表示フラグ
    isPaginationForKeywordSearchShown: computed(() => {
      return (
        group1.isKeywordSearch && // キーワード検索である
        group1.isListBookTableOfContentsLoaded && // ロード完了
        (
          group1.pageCountForSPKeywordSearch >= 2 || // 2ページ以上ある
          group1.prevBookForSPKeywordSearch || // 前の書籍がある
          group1.nextBookForSPKeywordSearch // 次の書籍がある
        )
      )
    }),
 
    // ### ハイライトキーワード関係 ###  
    // 現在選択中の書籍のハイライトキーワードの開始番号
    matchedStartNo: 0,
    // 現在選択中の書籍のハイライトキーワードの終了番号
    matchedEndNo: 0,
    // 現在選択中のハイライトキーワードの番号
    matchedCurrentNo: 0,
    // ヒットしたキーワードの総合計
    matchedTotal: 0,

    // 現在選択中のハイライトキーワードの番号(画面表示用)
    matchedCurrentNo4Disp: computed(() => {
      return common.breakComma(group1.matchedCurrentNo)
    }),
    // ヒットしたキーワードの総合計(画面表示用)
    matchedTotal4Disp: computed(() => {
      return common.breakComma(group1.matchedTotal)
    }),
    isMatchedTotalLoaded: false, // データ件数ロード完了フラグ


    // ### その他 ###

    // 目次一覧エリア表示用データロード完了フラグ
    isListBookTableOfContentsLoaded: false,

    // 検索をクリア実行判定フラグ
    isClearSearchExecuted: false,

    // 画面遷移履歴(SP用)
    historiesForSPKeywordSearch: [],

    // ヒストリーバック実行判定フラグ（historyBack()から呼ばれた場合true、通常はfalse）
    isHistoryBackExecuted: false,


    /**
     * 初期表示
     */
    init: () => {

      // 検索カテゴリを設定
      store.dispatch('search/setSearchCategory', 'book')

      if (typeof store.state.search.book !== 'undefined' && Object.keys(store.state.search.book).length > 0) {
        // 検索条件が設定されている場合（ダッシュボード、メニュー、保存検索条件画面、検索履歴画面などから来た場合）

        // 検索
        group1.searchWithOptions({ is_init: true })

      } else if (group1.search_text !== '') {
        // ダッシュボードやメニューでキーワードを入力し、
        // 検索ボタンではなく、メニューの「書籍」ボタンを押して遷移してきた場合、
        // キーワード入力欄にあるテキストで検索を実行する

        // group1.search_text と group1.is_fuzzy はすでにフォームに設定されているため、ここで設定しない。
        // メニューには絞り込みがないため、絞り込みの復元はしない。

        // 検索
        group1.searchWithOptions({ is_init: true })

      } else {
        // 検索条件が設定されていない場合

        // パッケージ・商品一覧エリアを表示
        group1.updatePackageAndProductsArea(true)
      }
    },

    /**
     * パッケージ・商品一覧エリアを更新
     * @param {boolean} isInit init() から実行された場合
     */
    updatePackageAndProductsArea: (isInit) => {

      // 初期化
      group1.packagesAndProductsDataExists = false
      group1.isListPackagesAndProductsLoaded = false
      group1.booksDataExists = false
      group1.isListBooksLoaded = false
      group1.bookListTableOfContentsExists = false
      group1.isMatchedTotalLoaded = false

      // パッケージ・商品一覧APIをコール
      const params = {}
      params.is_trial = 0 // 0=通常
      params.is_only_contact = 1 // 1=契約商品のみ
      params.search_range = 1 // キーワード検索対象範囲(1=書籍一覧画面)
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword // キーワード
        params.is_fuzzy = group1.is_fuzzy
      }
         
      apiQA.listPackagesAndProductsForSearch(params)
        .then(response => {
          if (response) {
            const { data } = response

            const packages = data.packages ?? []
            const books = data.books ?? []

            // パッケージ＆商品データ存在フラグ
            group1.packagesAndProductsDataExists = (packages.length + books.length > 0)

            if (!group1.packagesAndProductsDataExists) {
              // パッケージ＆商品データが存在しない場合

              // 書籍一覧エリアを検索結果なしで表示する
              group1.isListBooksLoaded = true
              group1.booksDataExists = false

              // 書籍目次一覧エリアを検索結果なしで表示する
              group1.isListBookTableOfContentsLoaded = true
              group1.packagesAndProductsDataExists = false
              group1.booksDataExists = false
            } else {

              const treeData = {
                id: 0,
                name: '',
                packages: data.packages
              }

              // 絞り込みツリーの全ノードの初期化
              const parentNodeMap = {}
              group1.initNodes(treeData, parentNodeMap)


              // 単体書籍一覧のisCheckedをfalseで初期化
              for (let i = 0; i < books.length; i++) {
                const searchCount = books[i].search_count
                books[i].search_count_disp = common.breakComma(searchCount)
                books[i].isChecked = false
              }

              if (isInit) {
                // init() から実行された場合

                if (Object.keys(store.state.bookList.packagesAndProductsAreaTreeData).length !== 0) {
                  // init() から実行された場合でパッケージツリー情報がストアにある場合(別ページから戻ってきた場合)は、
                  // チェック状態を復元する

                  // 絞り込みツリーのチェックされているノードのitemTypeとIDのリストを取得する
                  const treeDataOfStore = store.state.bookList.packagesAndProductsAreaTreeData
                  const checkedNodeItemTypeAndIds = []
                  getCheckedNodeItemTypeAndIds(treeDataOfStore, checkedNodeItemTypeAndIds)

                  // itemTypeとIDのリストにより、絞り込みツリーのチェック状態を設定する
                  setNodeCheckByItemTypeAndIds(treeData, checkedNodeItemTypeAndIds)
                }
                if (Object.keys(store.state.bookList.packagesAndProductsAreaBooks).length !== 0) {
                  // init() から実行された場合で単体書籍情報がストアにある場合(別ページから戻ってきた場合)は、
                  // チェック状態を復元する

                  const booksOfStore = store.state.bookList.packagesAndProductsAreaBooks

                  const singleBooksWork = []
                  for (let i = 0; i < books.length; i++) {
                    const productId = books[i].product_id
                    const bookId = books[i].book_id
                    for (let k = 0; k < booksOfStore.length; k++) {
                      if (booksOfStore[k].isChecked) {
                        const _productId = booksOfStore[k].product_id ?? 0
                        const _bookId = booksOfStore[k].book_id ?? 0
                        if (productId === _productId && bookId === _bookId) {
                          books[i].isChecked = true
                          singleBooksWork.push(productId + ',' + bookId)
                          break
                        }
                      }
                    }
                  }
                  group1.single_books = singleBooksWork
                }
              }

              group1.packagesAndProductsAreaTreeData = treeData
              group1.parentNodeMap = parentNodeMap
              group1.packagesAndProductsAreaBooks = books


              // 検索対象の商品IDのリスト
              const searchProductIds = []
              for (let i = 0; i < packages.length; i++) {
                for (let k = 0; k < packages[i].products.length; k++) {
                  const productId = packages[i].products[k].product_id
                  searchProductIds.push(productId)
                }
              }

              // 書籍一覧APIをコール
              // パッケージ・商品の絞り込みは、
              // パッケージor商品に所属する書籍IDをすべて書籍一覧APIに渡すことで、
              // 絞り込みを実施する。
              // そのためのパッケージ/商品 → 書籍IDリストの対応マップをここで生成する。
              const params = {}
              params.search_range = 1 // キーワード検索対象範囲「1=書籍一覧画面」
              params.product_ids = searchProductIds

              // 商品IDに対する全商品ID&書籍IDリストの対応マップを初期化
              const allIdMapListForProductIdMapWork = {}

              apiQA.listBooksForSearch(params)
                .then(response => {
                  if (response) {
                    const { data } = response

                    const products = data.products ?? []

                    for (let i = 0; i < products.length; i++) {
                      const productId = products[i].product_id

                      const idMapList = []
                      for (let k = 0; k < products[i].books.length; k++) {
                        const productId2 = products[i].books[k].product_id
                        const bookId2 = products[i].books[k].book_id
                        const map = {
                          product_id: productId2,
                          book_id: bookId2
                        }
                        idMapList.push(map)
                      }

                      // 商品IDに対する全書籍IDリストの対応マップを設定
                      const key = 'product_' + productId
                      allIdMapListForProductIdMapWork[key] = idMapList
                    }

                    group1.allIdMapListForProductIdMap = allIdMapListForProductIdMapWork
                  }
                })
 
              // 書籍一覧エリアを表示
              group1.updateBooksArea(isInit)
            }
          }
        })
        .finally(() => {
          group1.isListPackagesAndProductsLoaded = true
        })
    },

    /**
     * 書籍一覧エリアを更新
     * @param {boolean} isInit init() から実行された場合
     */
    updateBooksArea: (isInit) => {

      // 書籍一覧エリア表示用データロード完了フラグをfalseに設定
      group1.isListBooksLoaded = false

      // 書籍一覧APIをコール
      const params = {}
      params.search_range = 1 // キーワード検索対象範囲「1=書籍一覧画面」
      if (group1.idMapListOfCheckedProducts.length > 0) { // チェックなしの場合は絞り込まない
        params.product_books = group1.idMapListOfCheckedProducts // チェックされている書籍ID
      }
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword // キーワード
        params.is_fuzzy = group1.is_fuzzy
      }

      apiQA.listBooksForSearch(params)
        .then(response => {
          if (response) {
            const { data } = response

            const booksAreaProductsWork = data.products ?? []

            const books = data.books ?? []

            // 書籍データ存在フラグ
            group1.booksDataExists = (booksAreaProductsWork.length + books.length > 0)

            if (!group1.booksDataExists) {
              // 書籍データが存在しない場合

              // 書籍目次一覧エリアを検索結果なしで表示する
              group1.isListBookTableOfContentsLoaded = true
              group1.packagesAndProductsDataExists = false
              group1.booksDataExists = false
            } else {

              // 検索結果件数をカンマ区切りに加工
              for (let i = 0; i < books.length; i++) {
                const searchCount = books[i].search_count
                books[i].search_count_disp = common.breakComma(searchCount)
              }
              const booksAreaBooksWork = data.books ?? []

              let targetBookId = 0
              let targetBookName = ''
              let targetBookType = ''
              let targetNodeId = 0

              // 選択フラグ(書籍のハイライト表示フラグ)を追加する(フラグの初期化)
              for (let i = 0; i < booksAreaProductsWork.length; i++) {
                if (typeof booksAreaProductsWork[i].books !== 'undefined' && Array.isArray(booksAreaProductsWork[i].books)) {
                  for (let k = 0; k < booksAreaProductsWork[i].books.length; k++) {
                    const _nodeId = booksAreaProductsWork[i].books[k].id
                    const _productId = booksAreaProductsWork[i].books[k].product_id
                    const _bookId = booksAreaProductsWork[i].books[k].book_id
                    if (
                      store.state.bookList.selectedIdMapOfBooksArea &&
                      _productId === store.state.bookList.selectedIdMapOfBooksArea.product_id &&
                      _bookId === store.state.bookList.selectedIdMapOfBooksArea.book_id
                    ) {
                      targetBookType = 'package_book'
                      targetNodeId = _nodeId
                      booksAreaProductsWork[i].books[k].isSelected = true

                      // 見つかった書籍IDと書籍名を設定
                      targetBookId = booksAreaProductsWork[i].books[k].book_id
                      targetBookName = booksAreaProductsWork[i].books[k].name
                    } else {
                      booksAreaProductsWork[i].books[k].isSelected = false
                    }
                  }
                }
              }
              for (let i = 0; i < booksAreaBooksWork.length; i++) {
                const _nodeId = booksAreaBooksWork[i].id
                const _productId = booksAreaBooksWork[i].product_id
                const _bookId = booksAreaBooksWork[i].book_id
                if (
                  store.state.bookList.selectedIdMapOfBooksArea &&
                  _productId === store.state.bookList.selectedIdMapOfBooksArea.product_id &&
                  _bookId === store.state.bookList.selectedIdMapOfBooksArea.book_id
                ) {
                  targetBookType = 'single_book'
                  targetNodeId = _nodeId
                  booksAreaBooksWork[i].isSelected = true

                  // 見つかった書籍IDと書籍名を設定
                  targetBookId = booksAreaBooksWork[i].book_id
                  targetBookName = booksAreaBooksWork[i].name
                } else {
                  booksAreaBooksWork[i].isSelected = false
                }
              }

              if (targetBookId === 0) {
                // 対象の書籍が見つからなかった場合

                // 対象の書籍IDが設定されていない(初期表示)の場合は、最初の書籍の目次を表示する
                if (
                  booksAreaProductsWork && booksAreaProductsWork.length > 0 &&
                  booksAreaProductsWork[0].books && booksAreaProductsWork[0].books.length > 0
                ) {
                  // 目次を表示中の書籍の種類
                  targetBookType = 'package_book'
                  // 目次を表示中のノードID
                  targetNodeId = booksAreaProductsWork[0].books[0].id ?? 0
                  // 最初の書籍の書籍IDを設定
                  targetBookId = booksAreaProductsWork[0].books[0].book_id ?? 0
                  // 最初の書籍の書籍名を設定
                  targetBookName = booksAreaProductsWork[0].books[0].name ?? ''
                  // 最初の書籍をハイライト表示
                  booksAreaProductsWork[0].books[0].isSelected = true
                } else if (
                  booksAreaBooksWork && booksAreaBooksWork.length > 0
                ) {
                  // 目次を表示中の書籍の種類
                  targetBookType = 'single_book'
                  // 目次を表示中のノードID
                  targetNodeId = booksAreaBooksWork[0].id ?? 0
                  // 最初の書籍の書籍IDを設定
                  targetBookId = booksAreaBooksWork[0].book_id ?? 0
                  // 最初の書籍の書籍名を設定
                  targetBookName = booksAreaBooksWork[0].name ?? ''
                  // 最初の書籍をハイライト表示
                  booksAreaBooksWork[0].isSelected = true
                }
              }

              group1.booksAreaProducts = booksAreaProductsWork
              group1.booksAreaBooks = booksAreaBooksWork

              if (store.state.common.device === 'sp') {
                // SPの場合
                // 初期表示する書籍リスト画面（トップ画面）を画面遷移履歴(SP用)に追加

                // 画面遷移履歴(SP用)を初期化
                group1.historiesForSPKeywordSearch = []
              }

              if (targetBookId !== 0) {
                // 書籍目次一覧エリアを表示
                const moveToFirstHighlight = true
                const ifFromSelectBook = false
                const isLastPageForKeywordSearch = false
                group1.updateTableOfContentsArea(targetBookId, targetBookName, moveToFirstHighlight, ifFromSelectBook, isLastPageForKeywordSearch)
              }

            }
          }
        })
        .finally(() => {
          group1.isListBooksLoaded = true
        })
    },

    /**
     * 書籍目次一覧エリアを更新
     * @param {number} targetBookId 対象書籍の書籍ID
     * @param {number} targetBookName 対象書籍の書籍名
     * @param {number} moveToFirstHighlight キーワード検索のハイライトがある場合に
     *                                最初のハイライトの位置に移動する場合true、
     *                                最後のハイライトの位置に移動する場合はfalse
     *                                ハイライトが存在しない場合は無効
     * @param {number} ifFromSelectBook 書籍を選択した場合はtrue(SP用)
     * @param {boolean} isLastPageForKeywordSearch SPキーワード検索で最後のページを表示する場合はtrue（前の書籍に移動した時に使用。通常はfalseを設定）
     */
    updateTableOfContentsArea: (targetBookId, targetBookName, moveToFirstHighlight, ifFromSelectBook, isLastPageForKeywordSearch) => {

      if (targetBookId === 0) {
        // 書籍IDが未指定の場合
        return
      }

      // 初期化
      group1.pageCountForSPKeywordSearch = 0 // キーワードの存在するページ数(SP用)
      group1.keywordCountInPage = 0 // 現在のページに存在するキーワード件数(SP用)


      // 表示中の書籍ID（別ページから戻った時の復元用）（SPで使用）をストアに保存
      store.dispatch('bookList/setBookId', targetBookId)
      // 表示中の書籍名をストアに保存
      store.dispatch('bookList/setBookName', targetBookName)

      // 目次一覧エリア表示用データロード完了フラグをfalseに設定
      group1.isListBookTableOfContentsLoaded = false

      // 対象書籍より前までの書籍のキーワード件数の合計（対象書籍の開始番号）と全合計を取得する
      const { matchedCountBefore, matchedTotal } = logicCommonBookList.getMatchedCountBeforeAndMmatchedTotal(targetBookId, group1)
      group1.matchedTotal = matchedTotal

      // 書籍目次一覧APIをコール
      const params = {}
      params.book_id = targetBookId
      params.search_index_id = 0

      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        params.search_text = group1.lastSearchedKeyword
        params.is_fuzzy = group1.is_fuzzy
      }

      apiQA.listBookTableOfContents(params)
        .then(response => {
          if (response) {
            const { data } = response

            const list = data.list ?? []

            // 書籍目次ツリーデータ存在フラグ
            group1.bookListTableOfContentsExists = (list.length > 0)

            const listWork = list

            const treeData = {
              id: 0,
              title: '',
              children: listWork,
              isOpen: true,
              parent: null
            }

            // ツリーデータの全ノードにユニークなID(数値)を設定し直す
            const __param = { id: 10000 } // 分かりやすくpackage_id/product_id/book_idと被らないIDから始める
            common.addUniqueIdForTreeData(treeData, 'id', ['packages', 'products', 'books'], __param)
            treeData.id = 0 // ルートノードのidは必ず0

            // ツリーの要素に拡張項目を追加する
            group1.addExtraParamsToTreeData(treeData, null, group1.mode)

            if (group1.mode === 'list') {
              // モードが「list: 一覧表示(ドリルダウン)モード」の場合は全部閉じる
              group1.setAllChildrenOpen(treeData, false)
            } else if (group1.mode === 'search') {
              // モードが「search: キーワード検索モード」の場合は、
              // キーワードが1件以上存在するノードのみ開く
              group1.openNodeWhereKeywordExists(treeData, true)
            }

            // 現在の階層の書籍情報を設定
            group1.parentNodeId = -1
            group1.currentNodeId = 0
            group1.currentTitleFirstLine = group1.currentBookName
            group1.currentTitleAfterSecondLines = []
            group1.currentTableOfContents = treeData.children

            // ハイライト処理
            // ツリーデータのキーワード存在フラグが1のノードに対して前から順番に番号を付与していく
            group1.matchedStartNo = matchedCountBefore + 1
            const __param2 = {}
            __param2.no = group1.matchedStartNo // 開始番号
            group1.addMatchedNo(treeData, __param2)
            group1.matchedEndNo = __param2.no - 1 // 終了番号
            // 現在の番号を開始番号に設定
            group1.matchedCurrentNo = group1.matchedStartNo

            // ツリーデータを設定
            group1.bookListTableOfContentsAreaTreeData = treeData

            if (store.state.common.device === 'sp') {
              // SPの場合

              // 対象書籍の中のキーワードが存在するページ数
              const treeData = group1.bookListTableOfContentsAreaTreeData
              const result = {}
              result.pageCount = 0
              group1.getPageCountForSPKeywordSearch(treeData, result)
              // メンバ変数に保持
              group1.pageCountForSPKeywordSearch = result.pageCount

              if (group1.isKeywordSearch && ifFromSelectBook) {
                // キーワード検索の場合で、書籍選択(selectBook())から呼ばれた場合

                // 目次一覧を更新する
                const initialFound = true // 最初のページを表示するのでtrueに設定しておく
                const currentNodeId = 0 // ルートから探す
                const isNext = !isLastPageForKeywordSearch // 最初のページの場合はtrue、最後のページの場合はfalse
                group1.updateTableOfContentsForSPKeywordSearch(currentNodeId, initialFound, isNext)
              } else {
                const targetNodeId = store.state.bookList.targetNodeIdOfTableOfContents
                if (targetNodeId !== 0) {
                  // 他画面（詳細画面など）から戻ってきた場合
                  // 最後に表示した目次のノードIDがある場合は、そのノードIDのページを表示する
                  group1.changeTableOfContents(targetNodeId)
                } else {
                  // ドリルダウン＆ドリルアップ

                  // 画面遷移履歴(SP用)を追加
                  if (group1.mainListType === 'book') {
                    // 現在表示しているリストのタイプ（SP用）が「book=書籍一覧エリア」の場合
                    group1.addHistoriesForSPKeywordSearch(-1, 0, 0)
                  } else {
                    // 現在表示しているリストのタイプ（SP用）が「contents=目次一覧エリア」の場合
                    const selectedIdMap = store.state.bookList.selectedIdMapOfBooksArea
                    group1.addHistoriesForSPKeywordSearch(group1.currentNodeId, selectedIdMap.product_id, selectedIdMap.book_id)
                  }
                }
              }
            }

            Vue.nextTick(() => {
              // 現在のマッチキーワードがあれば移動
              const matchedNo = moveToFirstHighlight ? group1.matchedStartNo : group1.matchedEndNo
              const target = document.getElementById('matched_' + matchedNo)
              if (target) {
                target.scrollIntoView({block: 'center', behavior: 'auto'})
              }
            })
          }
        })
        .finally(() => {
          group1.isListBookTableOfContentsLoaded = true

          // ### 表示後の後処理 ###
          // 検索をクリア実行判定フラグをfalseにリセット
          group1.isClearSearchExecuted = false

          // ヒストリーバック実行判定フラグをfalseにリセット
          group1.isHistoryBackExecuted = false
        })

      // ### その他、画面表示のためのAPIコール ###

      // キーワード検索結果件数取得APIをコール
      const countParams = {}
      countParams.search_range = 1 // 検索対象：1=書籍一覧画面
      if (group1.lastSearchedKeyword !== '') {
        // キーワードが入力されている場合
        countParams.search_text = group1.lastSearchedKeyword
        countParams.is_fuzzy = group1.is_fuzzy
        if (group1.idMapListOfCheckedProducts.length > 0) {
          // 絞り込みをしている場合
          countParams.product_books = group1.idMapListOfCheckedProducts
        }
      } else {
        // キーワードが入力されてない場合（初期表示、検索をクリア）

        // 絞り込みをしていない場合は、現在表示している書籍に属するQA数
        if (group1.currentBookId !== 0) {
          countParams.book_ids = common.toArray(group1.currentBookId)
        }
      }

      // データ件数ロード完了フラグをfalseに設定
      group1.isMatchedTotalLoaded = false

      apiQA.countKeywordSearchResults(countParams)
        .then(r => {
          const data = r.data

          if (data.status === 0) {
            group1.matchedTotal = data.count
          }
        })
        .finally(() => {
          group1.isMatchedTotalLoaded = true
        })

    },

    /**
     * ツリーの要素に拡張項目を追加する
     */
    addExtraParamsToTreeData: (node, parentNode, mode) => {
      if (node.id === 0) {
        node.isOpen = true
      } else {
        // 全部閉じて初期化
        node.isOpen = false
      }
      node.parent = parentNode

      // タイトルが改行されている場合は、1行目の文字列と、2行目以降の文字列のリストに分離する
      const title = node.title
      let titleFirstLine = ''
      const titleAfterSecondLines = []
      if (typeof title !== 'undefined') {
        const arr = title.split(/\r?\n/)
        for (let i = 0; i < arr.length; i++) {
          if (i === 0) {
            titleFirstLine = arr[i]
          } else {
            titleAfterSecondLines.push(arr[i])
          }
        }
      }
      node.title_first_line = titleFirstLine
      node.title_after_second_lines = titleAfterSecondLines

      const keywordExists = node.keyword_exists

      if (mode === 'search') {
        // モードが「search: キーワード検索モード」の場合
        if (keywordExists) {
          // キーワードが存在する場合は、それより上の要素のisOpenをtrueにする
          group1.setAllParentElementsOpened(parentNode)
        }
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.addExtraParamsToTreeData(node.children[i], node, mode)
        }
      }
    },

    /**
     * キーワード存在するノードのみ開く
     * @param node ツリーのノード
     * @param isDown 下に見ていく場合はtrue、親要素を見る場合はfalse
     */
    openNodeWhereKeywordExists: (node, isDown) => {
      if (typeof node.children !== 'undefined') {
        // 対象ノードのいずれかの子ノードに、キーワードが存在するか（keyword_exists=1が存在するか）？

        let isFound = false
        for (let i = 0; i < node.children.length; i++) {
          if (
            typeof node.children[i].keyword_exists !== 'undefined' &&
            node.children[i].keyword_exists === 1
          ) {
            // キーワードが存在した
            isFound = true
            break
          }
        }

        if (isFound) {
          // 対象ノードのいずれかの子ノードにキーワードが存在した場合
          // 対象ノードを開く
          node.isOpen = true

          // 親ノードを見ていく
          group1.openNodeWhereKeywordExists(node.parent, false)
        }

        if (isDown) {
          // 子ノードを見ていく
          for (let i = 0; i < node.children.length; i++) {
            group1.openNodeWhereKeywordExists(node.children[i])
          }
        }
      }
    },

    /**
     * 対象要素よりも上の階層の要素を全てisOpen=trueに設定する
     */
    setAllParentElementsOpened: (parentNode) => {
      if (parentNode) {
        parentNode.isOpen = true
        if (parentNode.parent) {
          group1.setAllParentElementsOpened(parentNode.parent)
        }
      }
    },

    /**
     * ツリーデータのキーワード存在フラグが1のノードに対して前から順番に番号を付与していく
     * 用途：キーワードの存在するQAタイトルにid="match_result_{番号}"属性を付与し、
     * 前へ、次へボタン押下の移動で使用する
     * @param {object} node ツリーデータ
     * @param {object} __param 番号 (JSはプリミティブ型の参照渡しができないのでオブジェクトを使って参照渡しをする)
     */
    addMatchedNo: (node, __param = null) => {
    
      if (node.keyword_exists === 1) {
        node.matched_no = __param.no
        node.matched_no_disp = common.breakComma(__param.no)
        __param.no++
      }
    
      const key = 'children'
      if (typeof node[key] !== 'undefined' && Array.isArray(node[key])) {
        for (let i = 0; i < node[key].length; i++) {
          const childData = node[key][i]
          group1.addMatchedNo(childData, __param)
        }
      }  
    },

    /**
     * SPページ専用
     * 目次リストから書籍リストに変更する
     */
    changeToBookList: () => {

      if (!group1.isHistoryBackExecuted) {
        // 画面遷移履歴(SP用)を追加
        // トップの書籍リストは、ID=-1で設定
        group1.addHistoriesForSPKeywordSearch(-1, 0, 0)
      }

      // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
      store.dispatch('bookList/setMainListType', 'book')

      // ### 表示後の後処理 ###

      // 検索をクリア実行判定フラグをfalseにリセット
      group1.isClearSearchExecuted = false

      // ヒストリーバック実行判定フラグをfalseにリセット
      group1.isHistoryBackExecuted = false
    },

    /**
    * SPページ専用
    * 目次（ドリルダウン）のリストタイトルをクリックした場合
    */
    onListTitleOfTableOfContentsOfSPClicked: () => {
      if (group1.currentNodeId === 0) {
        group1.changeToBookList()
      } else {
        group1.changeTableOfContents(group1.parentNodeId)
      }
    },

    /**
    * SPページ専用
    * 目次（ドリルダウン）の項目（章・節・QAタイトル）をクリックした場合
    */
    onItemOfTableOfContentsOfSPClicked: (item) => {
      if (typeof item.children !== 'undefined' && item.children.length > 0) {
        // 子要素がある場合 → ドリルダウン
        group1.changeTableOfContents(item.id)
      } else {
        // 子要素が無い場合 → QAタイトルである → QA詳細に遷移
        group1.onQATitleClicked(item.id)
      }
    },

    /**
     * SPページ専用
     * 対象データがある階層に目次リストを設定
     * 
     * 【説明】
     * SPの場合は、ツリーを展開するのではなく、
     * ツリーの要素をクリックすると、ドリルダウン/ドリルアップしていく仕様である。
     * 初期表示で、updateTableOfContentsArea()メソッドで全ツリーを取得し、
     * その後、ツリーの要素をクリックすると、本メソッドが呼び、
     * 目次のリストを更新する(ドリルダウン/ドリルアップする)。
     * 
     * @param targetNodeId {number} ツリーのノードID
     */
    changeTableOfContents: (targetNodeId) => {
      
      if (targetNodeId === -1) {
        // トップ階層で、書籍名をクリックした場合は何もしない
        return
      }

      if (!group1.isHistoryBackExecuted) {
        // 画面遷移履歴(SP用)を追加
        const selectedIdMap = store.state.bookList.selectedIdMapOfBooksArea
        group1.addHistoriesForSPKeywordSearch(targetNodeId, selectedIdMap.product_id, selectedIdMap.book_id)
      }

      // 表示中の目次のノードID（別ページから戻った時の復元用）（SPで使用）をストアに保存
      store.dispatch('bookList/setTargetNodeIdOfTableOfContents', targetNodeId)

      if (group1.isClearSearchExecuted) {
        // 検索をクリアの場合
        // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
        store.dispatch('bookList/setMainListType', 'book')
      } else {
        // 現在表示しているリストのタイプ（SP用）を「contents=目次一覧エリア」に設定
        store.dispatch('bookList/setMainListType', 'contents')
      }

      const treeData = group1.bookListTableOfContentsAreaTreeData

      // ### SPのキーワード検索用の処理 ###
      // キーワード検索時のナビゲーション表示用の設定を生成
      group1.createNavigationSettingForSPKeywordSearch(targetNodeId)

      const target = {}
      group1.getTargetNode(treeData, targetNodeId, target)

      if (target.node) {

        // 現在の階層の目次リストを設定
        if (typeof target.node.children !== 'undefined') {
          group1.currentTableOfContents = target.node.children
        } else {
          group1.currentTableOfContents = []
        }
        
        if (!target.node.parent) {
          // トップ階層の場合
          group1.parentNodeId = -1
          group1.currentNodeId = targetNodeId
          group1.currentTitleFirstLine = group1.currentBookName
          group1.currentTitleAfterSecondLines = []
        } else {
          // トップ階層でない場合
          group1.parentNodeId = target.node.parent.id
          group1.currentNodeId = targetNodeId
          group1.currentTitleFirstLine = target.node.title_first_line
          group1.currentTitleAfterSecondLines = target.node.title_after_second_lines
        }

        // スクロールY座標を一番上に戻す
        const scrollArea = document.getElementById('scroll-area')
        if (scrollArea) {
          scrollArea.scrollTop = 0
        }
      }

      // ### 表示後の後処理 ###

      // 検索をクリア実行判定フラグをfalseにリセット
      group1.isClearSearchExecuted = false

      // ヒストリーバック実行判定フラグをfalseにリセット
      group1.isHistoryBackExecuted = false
    },

    /**
     * SPページ専用
     * 対象ノードを取得する
     */
    getTargetNode(node, targetNodeId, target) {
      if (node.id === targetNodeId) {
        target.node = node
        return
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.getTargetNode(node.children[i], targetNodeId, target)
        }
      }
    },

    /**
     * SPページ専用
     * キーワード検索時の目次一覧を更新する
     * @param {*} currentNodeId 
     * @param {*} initialFound 
     * @param {*} isNext 
     * @param {boolean} isLastPageForKeywordSearch SPキーワード検索で最後のページを表示する場合はtrue（前の書籍に移動した時に使用。通常はfalseを設定）
     */
    updateTableOfContentsForSPKeywordSearch: (currentNodeId, initialFound, isNext) => {

      // キーワードが存在する次の(前の)ノードを取得する
      const treeData = group1.bookListTableOfContentsAreaTreeData
      const param = {}
      param.found = initialFound
      const target = {}
      group1.getNextNodeForSPKeywordSearch(treeData, currentNodeId, isNext, param, target)
      if (target.node) {
        // 次の(前の)ノードが見つかった場合

        // 対象ページを表示する
        const targetNodeId = target.node.id
        group1.changeTableOfContents(targetNodeId)
      }
    },

    /**
     * SPページ専用
     * キーワード検索時のナビゲーション表示用の設定を生成
     * 
     * @param currentNodeId {number} 現在のノードID
     */
    createNavigationSettingForSPKeywordSearch: (currentNodeId) => {

      // 初期化
      group1.keywordCountInPage = 0
      group1.pageNoForSPKeywordSearch = 0
      group1.prevBookForSPKeywordSearch = null
      group1.nextBookForSPKeywordSearch = null

      // 現在の書籍の商品IDと書籍ID
      const selectedIdMapOfBooksArea = store.state.bookList.selectedIdMapOfBooksArea
      const targetProductId = selectedIdMapOfBooksArea.product_id
      const targetBookId = selectedIdMapOfBooksArea.book_id
      
      // キーワードが存在する次の(前の)ノードを取得する
      const treeData = group1.bookListTableOfContentsAreaTreeData
      const param = {}
      param.found = false
      const target = {}
      group1.getKeywordCountInPageForSPKeywordSearch(treeData, currentNodeId, param, target)
      // 対象ページに存在するキーワード件数
      group1.keywordCountInPage = target.keywordCountInPage

      // 現在のページのキーワードが存在するページ内でのページ番号
      const param2 = {}
      param2.found = false
      const target2 = {}
      group1.getPageNoForSPKeywordSearch(treeData, currentNodeId, param2, target2)
      group1.pageNoForSPKeywordSearch = target2.pageNo

      // 現在の書籍の次の(前の)書籍を取得する

      if (group1.pageNoForSPKeywordSearch === 1) {
        // 1ページの場合、前の書籍情報を取得
        const isNext3 = false
        const param3 = {}
        param3.found = false
        const result3 = {}
        group1.getNextBook(targetProductId, targetBookId, isNext3, param3, result3) 
        if (result3.book) {
          // 前の書籍が存在する場合
          group1.prevBookForSPKeywordSearch = result3.book
        }
      }

      if (group1.pageNoForSPKeywordSearch === group1.pageCountForSPKeywordSearch) {
        // 最後のページの場合、次の書籍情報を取得
        const isNext4 = true
        const param4 = {}
        param4.found = false
        const result4 = {}
        group1.getNextBook(targetProductId, targetBookId, isNext4, param4, result4) 
        if (result4.book) {
          // 次の書籍が存在する場合
          group1.nextBookForSPKeywordSearch = result4.book
        }
      }

    },

    /**
     * SPページ専用
     * キーワードが存在するページ数を取得
     * 
     * @param {object} node ツリーデータ
     * @param {object} [OUTPUT] result.pageCount キーワードが存在するページ数
     */
    getPageCountForSPKeywordSearch: (node, result) => {

      // 現在のノードに対する子ノードの一覧のいずれかにキーワードが存在するか？
      let isAnyKeywordExists = false
      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          const keywordExists = node.children[i].keyword_exists ?? 0
          if (keywordExists === 1) {
            isAnyKeywordExists = true
            break
          }
        }
      }

      if (isAnyKeywordExists) {
        // キーワードが存在した場合
        // ページ数を加算
        result.pageCount++
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.getPageCountForSPKeywordSearch(node.children[i], result)
        }
      }
    },

    /**
     * SPページ専用
     * キーワードが存在するページ内で、指定したノードIDに対するページ番号を取得
     * @param {object} node ツリーデータ
     * @param {number} targetNodeId 対象ノードID
     * @param {object} param.found 現在のノードが見つかった場合はtrue
     * @param {object} [OUTPUT] target.pageNo ページ番号
     */
    getPageNoForSPKeywordSearch: (node, targetNodeId, param, target) => {

      if (typeof target.pageNo === 'undefined') {
        target.pageNo = 0
      }

      if (param.found) {
        // 現在のノードを見つけた場合は終了
        return
      }

      // 現在のノードに対する子ノードの一覧のいずれかにキーワードが存在するか？
      let isAnyKeywordExists = false
      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          const keywordExists = node.children[i].keyword_exists ?? 0
          if (keywordExists === 1) {
            isAnyKeywordExists = true
            break
          }
        }
      }

      if (isAnyKeywordExists) {
        // キーワードが存在した場合
        // ページを数える
        target.pageNo++
      }

      if (!param.found) {
        // 現在のノードがまだ見つかっていない
        if (node.id === targetNodeId) {
          // 現在のノードを見つけた
          param.found = true
          return
        }
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.getPageNoForSPKeywordSearch(node.children[i], targetNodeId, param, target)
        }
      }      
    },

    /**
     * SPページ専用
     * キーワードが存在する次の(前の)ノードを取得する
     * 
     * @param {object} node ツリーデータ
     * @param {number} currentNodeId 現在のノード
     * @param {boolean} isNext true=次を探す、false=前を探す
     * @param {object} param.found 現在のノードが見つかった場合はtrue
     * @param {object} [OUTPUT] target.node キーワードが存在する次の(前の)ノード
     */
    getNextNodeForSPKeywordSearch: (node, currentNodeId, isNext, param, target) => {

      if (typeof target.node === 'undefined') {
        target.node = null
      }

      if (target.node) {
        // 対象ノードが見つかった場合は以降の処理をしない（再帰処理から脱出）
        return
      }


      if (!param.found) {
        // 現在のノードがまだ見つかっていない
        if (node.id === currentNodeId) {
          // 現在のノードを見つけた
          param.found = true
        }
      } else {
        // 現在のノードが見つかった後は、次のキーワードが存在するノード（一覧）を探す

        // 現在のノードに対する子ノードの一覧のいずれかにキーワードが存在するか？
        let isAnyKeywordExists = false
        if (typeof node.children !== 'undefined') {
          for (let i = 0; i < node.children.length; i++) {
            const keywordExists = node.children[i].keyword_exists ?? 0
            if (keywordExists === 1) {
              isAnyKeywordExists = true
              break
            }
          }
        }

        if (isAnyKeywordExists) {
          // キーワードが存在した場合
          if (!target.node) {
            // 次の(前の)ノード(現在のノード発見後、最初に発見したノード)
            target.node = node

            return
          }
        }
      }

      if (typeof node.children !== 'undefined') {
        if (isNext) {
          // 次を探す場合
          for (let i = 0; i < node.children.length; i++) {
            group1.getNextNodeForSPKeywordSearch(node.children[i], currentNodeId, isNext, param, target)
          }
        } else {
          // 前を探す場合
          for (let i = node.children.length - 1; i >= 0; i--) {
            group1.getNextNodeForSPKeywordSearch(node.children[i], currentNodeId, isNext, param, target)
          }
        }
      }
    },

    /**
     * SPページ専用
     * 対象ページに存在するキーワード件数を取得
     *
     * @param {object} node ツリーデータ
     * @param {number} currentNodeId 現在のノード
     * @param {object} param.found 現在のノードが見つかった場合はtrue
     * @param {object} [OUTPUT] target.keywordCountInPage キーワードが存在する次の(前の)ページに存在するキーワード件数
     */
    getKeywordCountInPageForSPKeywordSearch: (node, currentNodeId, param, target) => {

      if (typeof target.keywordCountInPage === 'undefined') {
        target.keywordCountInPage = 0
      }

      if (target.node) {
        // 対象ノードが見つかった場合は以降の処理をしない（再帰処理から脱出）
        return
      }

      if (!param.found) {
        // 現在のノードがまだ見つかっていない
        if (node.id === currentNodeId) {
          // 現在のノードを見つけた
          param.found = true

          // ページ内のキーワードにマッチしたQA数を数える
          target.keywordCountInPage = 0
          if (typeof node.children !== 'undefined') {
            for (let i = 0; i < node.children.length; i++) {
              const keywordExists = node.children[i].keyword_exists ?? 0
              if (keywordExists === 1) {
                target.keywordCountInPage++
              }
            }
          }
        }
      }

      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          group1.getKeywordCountInPageForSPKeywordSearch(node.children[i], currentNodeId, param, target)
        }
      }
    },

    /**
     * 対象書籍の次の(前の)書籍を取得する
     * 
     * 【用途】
     *  SPのキーワード検索の「前へ」「次へ」ナビで、対象(現在の)書籍の次の(前の)書籍情報を取得する
     * （1ページ、最後のページの場合に確認する）
     *  ※汎用性があるのでSP専用ではない
     *
     * @param {number} targetProductId 対象の書籍の商品ID
     * @param {number} targetBookId 対象の書籍の書籍ID
     * @param {boolean} isNext true=次を探す、false=前を探す
     * @param {object} param.found 現在の書籍が見つかった場合はtrue
     * @param {object} result.book [OUTPUT] 対象の書籍情報
     */
    getNextBook: (targetProductId, targetBookId, isNext, param, result) => {
      
      if (typeof result.book === 'undefined') {
        result.book = null
      }

      const booksAreaProducts = group1.booksAreaProducts
      const booksAreaBooks = group1.booksAreaBooks

      if (isNext) {
        // 次を探す場合

        // パッケージ書籍
        for (let i = 0; i < booksAreaProducts.length; i++) {
          for (let k = 0; k < booksAreaProducts[i].books.length; k++) {
            const book = booksAreaProducts[i].books[k]
            const _productId = booksAreaProducts[i].books[k].product_id
            const _bookId = booksAreaProducts[i].books[k].book_id
            if (!param.found) {
              // 対象書籍が見つかっていない場合
              if (_productId === targetProductId && _bookId === targetBookId) {
                // 対象書籍が見つかった
                param.found = true
              }
            } else {
              // 対象書籍の次の書籍
              result.book = book
              result.book.book_type = 'package_book'
              return
            }
          }
        }

        // 単体書籍
        for (let i = 0; i < booksAreaBooks.length; i++) {
          const book = booksAreaBooks[i]
          const _productId = booksAreaBooks[i].product_id
          const _bookId = booksAreaBooks[i].book_id
          if (!param.found) {
            // 対象書籍が見つかっていない場合
            if (_productId === targetProductId && _bookId === targetBookId) {
              // 対象書籍が見つかった
              param.found = true
            }
          } else {
            // 対象書籍の次の書籍
            result.book = book
            result.book.book_type = 'single_book'
            return
          }
        }
      } else {
        // 前を探す場合

        // パッケージ書籍
        for (let i = booksAreaProducts.length - 1; i >= 0; i--) {
          for (let k = booksAreaProducts[i].books.length - 1; k >= 0; k--) {
            const book = booksAreaProducts[i].books[k]
            const _productId = booksAreaProducts[i].books[k].product_id
            const _bookId = booksAreaProducts[i].books[k].book_id
            if (!param.found) {
              // 対象書籍が見つかっていない場合
              if (_productId === targetProductId && _bookId === targetBookId) {
                // 対象書籍が見つかった
                param.found = true
              }
            } else {
              // 対象書籍の次の書籍
              result.book = book
              result.book.book_type = 'package_book'
              return
            }
          }
        }

        // 単体書籍
        for (let i = booksAreaBooks.length - 1; i >= 0; i--) {
          const book = booksAreaBooks[i]
          const _productId = booksAreaBooks[i].product_id
          const _bookId = booksAreaBooks[i].book_id
          if (!param.found) {
            // 対象書籍が見つかっていない場合
            if (_productId === targetProductId && _bookId === targetBookId) {
              // 対象書籍が見つかった
              param.found = true
            }
          } else {
            // 対象書籍の次の書籍
            result.book = book
            result.book.book_type = 'single_book'
            return
          }
        }
      }
    },

    /**
    * 絞り込みツリーの全ノードの初期化
    */
    initNodes: (node, parentNodeMap, parentNode = null) => {

      node.isChecked = false

      let parentNodeMapKey = ''
      if (typeof node.package_id !== 'undefined') {
        node.itemType = 'package'
        parentNodeMapKey = 'package_' + node.package_id
      } else if (typeof node.product_id !== 'undefined') {
        node.itemType = 'product'
        parentNodeMapKey = 'product_' + node.product_id
      }
      parentNodeMap[parentNodeMapKey] = parentNode

      if (typeof node.packages !== 'undefined') {
        for (let i = 0; i < node.packages.length; i++) {
          group1.initNodes(node.packages[i], parentNodeMap, node)
        }
      }
      if (typeof node.products !== 'undefined') {
        for (let i = 0; i < node.products.length; i++) {
          group1.initNodes(node.products[i], parentNodeMap, node)
        }
      }
    },


    /**
     * 検索を実行する
     */
    search: () => {
      const options = {}
      group1.searchWithOptions(options)
    },

    /**
     * 検索を実行する（オプション指定）
     */
    searchWithOptions(options) {
      
      let searchCategory
      let searchText
      let isFuzzy
      if (
        typeof options !== 'undefined' &&
        typeof options.searchCategory !== 'undefined'
      ) {
        searchCategory = options.searchCategory
        searchText = options.search_text
        isFuzzy = options.is_fuzzy
      } else {
        searchCategory = group1.searchCategory
        searchText = group1.search_text
        isFuzzy = group1.is_fuzzy
      }

      if (searchCategory !== 'book') {
        // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
        searchByKeyword(context, searchCategory, searchText, isFuzzy) 
        return
      }

      // init()から実行されたか
      let isInit = false
      if (typeof options.is_init !== 'undefined') {
        isInit = options.is_init
      }

      // 同画面でキーワード検索が実行されたか？
      // (1)キーワード入力欄でEnterを押した
      // (2)キーワード入力欄の検索ボタンを押した場合
      // ※他の画面から遷移してきた場合はfalse
      let isSearchExecutedAtSameScreen = false
      if (typeof options.search_executed !== 'undefined') {
        isSearchExecutedAtSameScreen = options.search_executed
      }

      // 初期化
      group1.isListPackagesAndProductsLoaded = false
      group1.isListBooksLoaded = false
      group1.isListBookTableOfContentsLoaded = false

      if (isSearchExecutedAtSameScreen) {
        // 同画面での検索の場合

        // 表示中の目次のノードIDをリセット
        store.dispatch('bookList/setTargetNodeIdOfTableOfContents', 0)
      } else {
        // 同画面以外から検索された場合
      }

      // 検索カテゴリを設定（init()で設定されると思うが念のため設定）
      store.dispatch('search/setSearchCategory', 'book')

      if (store.state.common.device === 'sp') {
        // キーワード入力欄のフォーカス表示フラグをfalseに設定
        state.isFocusInput = false
        // キーワード検索ウィンドウを閉じる
        state.visibleBookSearchByKeyword = false

        if (isSearchExecutedAtSameScreen) {
          // 同画面での検索の場合
  
          // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
          store.dispatch('bookList/setMainListType', 'book')
        }
      }

      if (isSearchExecutedAtSameScreen) {
        // 同画面での検索の場合

        // 絞り込みのチェックをすべてクリア
        // パッケージ商品
        const treeData = group1.packagesAndProductsAreaTreeData
        group1.setAllNoodesCheck(treeData, false)
        group1.packagesAndProductsAreaTreeData = treeData
        // 単体書籍
        group1.single_books = []
        group1.packagesAndProductsAreaBooks = []
        // ストアに保持している絞り込み情報をクリア
        store.dispatch('bookList/setPackagesAndProductsAreaTreeData', {})
        store.dispatch('bookList/setPackagesAndProductsAreaBooks', [])
        store.dispatch('bookList/setIdMapListOfCheckedProducts', [])
      }

      // 最後に検索実行したキーワードを設定
      group1.lastSearchedKeyword = searchText

      // 検索条件をストアに保持
      const searchParams = {
        search_text: searchText,
        is_fuzzy: group1.is_fuzzy
      }
      store.dispatch('search/setBookSearchParam', searchParams)

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // パッケージ・商品一覧、書籍一覧、書籍目次一覧を検索する処理
      group1.updatePackageAndProductsArea(isInit)
    },

    /**
     * 詳細検索を実行する(SP画面で使用)
     * 用途：詳細検索ウィンドウの詳細検索実行ボタン押下時
     */
    searchDetail: (isResetSearchCondition) => {
      // 検索一覧画面に遷移
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQAList' }).catch(() => {})
      } else {
        router.push({ name: 'PCQAList' }).catch(() => {})
      }
    },

    /**
     * 検索をクリア
     */
    clearSearch: () => {

      // 初期化
      group1.isListBookTableOfContentsLoaded = false
      group1.isListBooksLoaded = false 
      group1.isListBooksAndFormDownloadsLoaded = false
      group1.matchedTotal = 0
      group1.isMatchedTotalLoaded = false

     
      // 各検索条件をクリア
      group1.packagesAndProductsAreaTreeData = {}
      group1.single_books = []
      group1.lastSearchedKeyword = ''

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: group1.searchCategory, searchText: '', isFuzzy: 0 })

      // ストアに保持している検索条件をクリア
      store.dispatch('search/setBookSearchParam', {})

      // ストアに保持している絞り込み情報をクリア
      store.dispatch('bookList/setPackagesAndProductsAreaTreeData', {})
      store.dispatch('bookList/setPackagesAndProductsAreaBooks', [])
      store.dispatch('bookList/setIdMapListOfCheckedProducts', [])
    
      // モードを「list: 一覧表示(ドリルダウン)モード」に設定
      group1.mode = 'list'

      if (store.state.common.device === 'sp') {
        // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
        store.dispatch('bookList/setMainListType', 'book')

        // 画面遷移履歴(SP用)をリセット
        group1.historiesForSPKeywordSearch = []

        // 表示中の目次のノードIDをリセット
        store.dispatch('bookList/setTargetNodeIdOfTableOfContents', 0)

        // キーワード検索ウィンドウを閉じる
        state.visibleBookSearchByKeyword = false
      }

      // 検索をクリア実行判定フラグをtrueに設定
      group1.isClearSearchExecuted = true

      // パッケージ・商品一覧、書籍一覧、書籍目次一覧を検索する処理
      group1.updatePackageAndProductsArea(true)
    },

    /**
     * 絞り込みツリーの全ノードのチェック状態を設定
     */
    setAllNoodesCheck: (node, isChecked) => {
      node.isChecked = isChecked
      if (typeof node.packages !== 'undefined') {
        for (let i = 0; i < node.packages.length; i++) {
          group1.setAllNoodesCheck(node.packages[i], isChecked)
        }
      }
      if (typeof node.products !== 'undefined') {
        for (let i = 0; i < node.products.length; i++) {
          group1.setAllNoodesCheck(node.products[i], isChecked)
        }
      }
      if (typeof node.books !== 'undefined') {
        for (let i = 0; i < node.books.length; i++) {
          group1.setAllNoodesCheck(node.books[i], isChecked)
        }
      }
    },

    /**
     * 目次をすべて開く
     * 用途：目次一覧エリアの「すべて開く」ボタン押下時
     */
    openAllTableOfContents: () => {
      const treeData = group1.bookListTableOfContentsAreaTreeData
      group1.setAllChildrenOpen(treeData, true)
      group1.bookListTableOfContentsAreaTreeData = treeData
    },

    /**
     * 目次を全て閉じる
     * 用途：目次一覧エリアの「すべて閉じる」ボタン押下時
     */
    closeAllTableOfContents: () => {
      const treeData = group1.bookListTableOfContentsAreaTreeData
      group1.setAllChildrenOpen(treeData, false)
      group1.bookListTableOfContentsAreaTreeData = treeData
    },

    /**
     * 目次の全要素を開く/閉じる
     */
    setAllChildrenOpen: (node, flag) => {
      if (typeof node.children !== 'undefined') {
        const children = node.children
        for (let i = 0; i < children.length; i++) {
          children[i].isOpen = flag
  
          group1.setAllChildrenOpen(children[i], flag)
        }
      }
    }, 

    /**
     * チェックされた商品の商品ID&書籍IDリスト検出し、
     * 変数group1.idMapListOfCheckedProductsに設定する
     */
    setIdMapListOfCheckedProducts: () => {

      const idMapListOfCheckedProducts = []

      // パッケージ＆商品ツリーでチェックされている商品の商品IDリスト
      const checkedProductIds = []
      const treeData = group1.packagesAndProductsAreaTreeData
      getCheckedProductIds(treeData, checkedProductIds)

      // 商品IDに対する全商品ID＆書籍IDリスト
      for (let i = 0; i < checkedProductIds.length; i++) {
        const key = 'product_' + checkedProductIds[i]
        if (typeof group1.allIdMapListForProductIdMap[key] !== 'undefined') {
          const idMapList = group1.allIdMapListForProductIdMap[key]
          for (let k = 0; k < idMapList.length; k++) {
            idMapListOfCheckedProducts.push(idMapList[k])
          }
        }
      }

      // 単体書籍リストでチェックされている書籍の書籍IDリストを取得し、リストに追加
      const idsOfSingleBooks = group1.single_books
      for (let i = 0; i < idsOfSingleBooks.length; i++) {
        if (idsOfSingleBooks[i] !== '') {
          const arr = idsOfSingleBooks[i].split(',')
          const productId = Number(arr[0]) ?? 0
          const bookId = Number(arr[1]) ?? 0
          const map = {
            product_id: productId,
            book_id: bookId
          }
          idMapListOfCheckedProducts.push(map)
        }
      }

      // ストアに保存
      store.dispatch('bookList/setIdMapListOfCheckedProducts', idMapListOfCheckedProducts)
    },

    /**
     * パッケージ＆商品一覧ツリーのいずれかのチェックボックスがチェックされた場合
     */
    onPackageAndProductsTreeItemClicked: ({nodeId, targetIdsMap}) => {

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // 絞り込みツリー：チェック状態を伝播させる
      const treeData = group1.packagesAndProductsAreaTreeData 
      propagateCheckedRecursively(treeData, nodeId, group1.parentNodeMap)
      
      // チェックされた商品の商品ID＆書籍IDリストを設定する
      group1.setIdMapListOfCheckedProducts()

      // パッケージ商品、単体書籍の絞り込みチェック状態をストアに保存する
      store.dispatch('bookList/setPackagesAndProductsAreaTreeData', treeData)
      store.dispatch('bookList/setPackagesAndProductsAreaBooks', group1.packagesAndProductsAreaBooks)

      if (store.state.common.device === 'sp') {
        // トップの書籍一覧を表示する

        // 現在の書籍を初期化
        group1.currentBookId = 0
        group1.currentBookName = ''

        // 表示中の目次のノードIDを初期化
        store.dispatch('bookList/setTargetNodeIdOfTableOfContents', 0)

        // 現在表示しているリストのタイプ（SP用）を「book=書籍一覧エリア」に設定
        store.dispatch('bookList/setMainListType', 'book')

        store.dispatch('common/showToast', { text: '絞り込み条件を変更しました' })
      }

      // 書籍一覧、書籍目次一覧を検索する処理
      group1.updateBooksArea(false)
    },

    /**
     * 単体書籍リストのいずれかのチェックボックスがチェックされた場合
     */
    onSingleBookClicked: () => {

      // モードを「search: キーワード検索モード」に設定
      group1.mode = 'search'

      // 絞り込みのチェック状態を設定
      const idsOfSingleBooks = group1.single_books
      const books = group1.packagesAndProductsAreaBooks
      for (let i = 0; i < books.length; i++) {
        const productId = books[i].product_id
        const bookId = books[i].book_id
        let isFound = false
        for (let k = 0; k < idsOfSingleBooks.length; k++) {
          if (idsOfSingleBooks[k] !== '') {
            const arr = idsOfSingleBooks[k].split(',')
            const _productId = Number(arr[0]) ?? 0
            const _bookId = Number(arr[1]) ?? 0
            if (productId === _productId && bookId === _bookId) {
              isFound = true
              break
            }
          }
        }
        books[i].isChecked = isFound
      }
      group1.packagesAndProductsAreaBooks = books

      // チェックされた商品の商品ID＆書籍IDリストを設定する
      group1.setIdMapListOfCheckedProducts()

      // パッケージ商品、単体書籍の絞り込みチェック状態をストアに保存する
      const treeData = group1.packagesAndProductsAreaTreeData 
      store.dispatch('bookList/setPackagesAndProductsAreaTreeData', treeData)
      store.dispatch('bookList/setPackagesAndProductsAreaBooks', group1.packagesAndProductsAreaBooks)

      // 書籍一覧、書籍目次一覧を検索する処理
      group1.updateBooksArea(false)

      if (store.state.common.device === 'sp') {
        store.dispatch('common/showToast', { text: '絞り込み条件を変更しました' })
      }
    },

    /**
     * 書籍を選択した場合
     * 
     * @param {string} bookType 書籍の種類(package_book=パッケージ商品、single_book=単体書籍)
     * @param {number} nodeId ツリー用ID
     * @param {number} productId 商品ID
     * @param {number} bookId 書籍ID
     * @param {boolean} isLastPageForKeywordSearch SPキーワード検索で最後のページを表示する場合はtrue（前の書籍に移動した時に使用。通常はfalseを設定）
     */
    selectBook: (bookType, nodeId, productId, bookId, bookName, isLastPageForKeywordSearch) => {

      // 目次を表示中の書籍のIDを設定
      group1.currentBookId = bookId
      group1.currentBookName = bookName

      // ストア保持項目の設定（書籍一覧に戻った用）
      store.dispatch('bookList/setBookId', bookId)
      store.dispatch('bookList/setBookName', bookName)

      // store保持項目の設定
      store.dispatch('qa/setBookId', bookId)
      store.dispatch('qa/setBookName', bookName)
      store.dispatch('qa/setQaId', 0)
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setNumberCarouselVisible', 0)

      if (store.state.common.device === 'sp') {
        // 現在表示しているリストのタイプ（SP用）を「contents=目次一覧エリア」に設定
        store.dispatch('bookList/setMainListType', 'contents')
      }

      // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)を保持
      const selectedIdMap = {
        product_id: productId,
        book_id: bookId
      }
      store.dispatch('bookList/setSelectedIdMapOfBooksArea', selectedIdMap)

      // 書籍エリアのハイライトを設定
      logicCommonBookList.setHighlightedItemInBooksArea(bookType, nodeId, group1)

      // 書籍目次一覧エリアを更新
      const moveToFirstHighlight = true
      const ifFromSelectBook = true
      group1.updateTableOfContentsArea(bookId, bookName, moveToFirstHighlight, ifFromSelectBook, isLastPageForKeywordSearch)
    },

    /**
     * 目次一覧のQAタイトルをクリックした場合
     */
    onQATitleClicked: (qaId) => {

      // QA IDを保存
      // 書籍ID、書籍名は、QA詳細画面(QADetail.js)で取得するため、0に設定しておく。
      store.dispatch('qa/setBookId', 0)
      store.dispatch('qa/setBookName', '')
      store.dispatch('qa/setQaId', qaId)
      store.dispatch('qa/setSearchIndexId', 0)
      store.dispatch('qa/setNumberCarouselVisible', 0)

      // QA詳細画面に遷移(URLにQAIDを表示する)
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQADetail', params: { qaId: qaId } })
      } else {
        router.push({ name: 'PCQADetail', params: { qaId: qaId } })
      }
    },

    /**
     * 後で見るの状態が変わった場合
     */
    onViewLaterChanged: (result) => {

      const qaId = result.id
      const isAfter = result.isAfter ? 1 : 0
      const afterId = result.afterId

      // ツリーデータの対象QAの後で見るフラグを更新
      const treeData = group1.bookListTableOfContentsAreaTreeData
      group1.updateIsAfter(treeData, qaId, isAfter, afterId)
    },

    /**
     *  ツリーデータの対象QAの後で見るフラグを更新
     */
    updateIsAfter: (node, qaId, isAfter, afterId) => {
      if (typeof node.children !== 'undefined') {
        for (let i = 0; i < node.children.length; i++) {
          if (node.children[i].id === qaId) {
            node.children[i].after_id = afterId
          }
          group1.updateIsAfter(node.children[i], qaId, isAfter, afterId)
        }
      }
    },

    /**
     * 画面遷移履歴(SP用)を追加
     * @param nodeId {number} ノードID
     * @param productId {number} 商品ID
     * @param bookId {number} 書籍ID
     */
    addHistoriesForSPKeywordSearch: (nodeId, productId, bookId) => {

      const map = {
        node_id: nodeId,
        product_id: productId,
        book_id: bookId
      }
      group1.historiesForSPKeywordSearch.push(map)

      // 履歴のデバッグ出力
      group1.debugHistory()
    },

    /**
     * 履歴のデバッグ出力
     */
    debugHistory: () => {
      // console.log('### debugHistory() ###')
      // for (let i = 0; i < group1.historiesForSPKeywordSearch.length; i++) {
      //   const map = group1.historiesForSPKeywordSearch[i]
      //   console.log('node_id = ' + map.node_id + ', product_id = ' + map.product_id + ', book_id = ' + map.book_id)
      // }
    },

    /**
     * 画面左上の戻るボタン（「＜」アイコン）を押した場合の処理
     */
    historyBack: () => {

      // ヒストリーバック実行判定フラグをtrueに設定
      group1.isHistoryBackExecuted = true

      if (store.state.common.device === 'sp') {
        // SPの場合
        if (group1.mainListType === 'contents') {
          // 現在表示しているリストのタイプ（SP用）が「contents=目次一覧エリア」の場合

          // 現在のページ（履歴の最後のページ）を削除＆変数に格納
          const currentBookInfoMap = group1.historiesForSPKeywordSearch.pop()

          // 履歴のデバッグ出力
          group1.debugHistory()

          if (group1.historiesForSPKeywordSearch.length === 0) {
            // 履歴が無い場合
            // 書籍一覧を表示
            group1.changeToBookList()
          } else {
            // 履歴がある場合

            const lastIndex = group1.historiesForSPKeywordSearch.length - 1
            const historyBookInfoMap = group1.historiesForSPKeywordSearch[lastIndex]
            const historyNodeId = historyBookInfoMap.node_id
      
            if (historyNodeId === -1) {
              // 書籍一覧の場合
              // ※changeToBookList()メソッド内で、-1で登録している
              group1.changeToBookList()
            } else {
              // 目次の場合
 
              if (
                currentBookInfoMap.product_id === historyBookInfoMap.product_id &&
                currentBookInfoMap.book_id === historyBookInfoMap.book_id
              ) {
                // 同じ書籍での遷移の場合

                // 対象ページを表示
                group1.changeTableOfContents(historyNodeId)
              } else {
                // 書籍が変わった場合

                const booksAreaProducts = group1.booksAreaProducts
                const booksAreaBooks = group1.booksAreaBooks

                // 処理しやすいようにパッケージ書籍と単体書籍をすべて１つのリストに追加する
                const bookList = []
                // パッケージ書籍
                for (let i = 0; i < booksAreaProducts.length; i++) {
                  for (let k = 0; k < booksAreaProducts[i].books.length; k++) {
                    const book = booksAreaProducts[i].books[k]
                    book.book_type = 'package_book'
                    bookList.push(book)
                  }
                }
                // 単体書籍
                for (let i = 0; i < booksAreaBooks.length; i++) {
                  const book = booksAreaBooks[i]
                  book.book_type = 'single_book'
                  bookList.push(book)
                }

                // 現在の書籍を探し、ひとつ前の履歴の書籍が、書籍リストで、現在の書籍よりも前か後ろかを判定
                let bookType = ''
                const nodeId = historyBookInfoMap.id
                const productId = historyBookInfoMap.product_id
                const bookId = historyBookInfoMap.book_id
                let isLastPageForKeywordSearch = false
                let bookName = ''

                for (let i = 0; i < bookList.length; i++) {
                  const book = bookList[i]
                  if (
                    book.product_id === currentBookInfoMap.product_id &&
                    book.book_id === currentBookInfoMap.book_id
                  ) {
                    // 見つかった場合
                    // ひとつ前の履歴の書籍が、書籍リストで、現在の書籍よりも前か後ろかを判定
                    const prevBook = bookList[i - 1] ?? null
                    if (prevBook) {
                      if (
                        prevBook.product_id === historyBookInfoMap.product_id &&
                        prevBook.book_id === historyBookInfoMap.book_id
                      ) {
                        // 前の書籍だった場合
                        bookType = prevBook.book_type
                        isLastPageForKeywordSearch = true // 最後のページを表示
                        bookName = prevBook.name
                      }
                    }
                    const nextBook = bookList[i + 1] ?? null
                    if (nextBook) {
                      if (
                        nextBook.product_id === historyBookInfoMap.product_id &&
                        nextBook.book_id === historyBookInfoMap.book_id
                      ) {
                        // 次の書籍だった場合
                        bookType = nextBook.book_type
                        isLastPageForKeywordSearch = false // 1ページを表示
                        bookName = nextBook.name
                      }
                    }
                  }
                }

                group1.selectBook(bookType, nodeId, productId, bookId, bookName, isLastPageForKeywordSearch)
              }
            }
          }
        } else {
          // 現在表示しているリストのタイプ（SP用）が「book=書籍一覧エリア」の場合
          router.go(-1)
        }
      } else {
        // PCの場合
        router.go(-1)
      }
    }

  })

  const searchSelect = reactive({
    isFocusInput: false,
    currentValue: 0
  })

  const state = reactive({
    visibleMenu: false,
    visibleBookSearchExtract: false,
    visibleBookSearchByKeyword: false,
    visibleBasicToastLator: false,
    visibleBasicToastSave: false,
    visibleSearchDetail: false, // 詳細検索ウィンドウ表示フラグ
    isFocusInput: false // SP用:キーワード入力欄のフォーカス表示フラグ
  })

  return {
    group1,
    state,
    searchSelect
  }
}
